import { render, staticRenderFns } from "./noticeProject.vue?vue&type=template&id=dcd6a2d6&scoped=true&"
import script from "./noticeProject.vue?vue&type=script&lang=js&"
export * from "./noticeProject.vue?vue&type=script&lang=js&"
import style0 from "./noticeProject.vue?vue&type=style&index=0&id=dcd6a2d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd6a2d6",
  null
  
)

export default component.exports